import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const institutionConfidentialityDeedApi = {
    getInstitutionConfidentialityDeedByInstitutionId: (institutionId: number): Observable<Dtos.GetInstitutionConfidentialityDeedByInstitutionIdResponse> => {
        //Create the request.
        let request: Dtos.GetInstitutionConfidentialityDeedByInstitutionId = new Dtos.GetInstitutionConfidentialityDeedByInstitutionId();
        request.institutionId = institutionId;

        //Send request.
        const response: Promise<Dtos.GetInstitutionConfidentialityDeedByInstitutionIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getInstitutionConfidentialityDeedById: (id: number): Observable<Dtos.GetInstitutionConfidentialityDeedByIdResponse> => {
        //Create the request.
        let request: Dtos.GetInstitutionConfidentialityDeedById = new Dtos.GetInstitutionConfidentialityDeedById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetInstitutionConfidentialityDeedByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setInstitutionConfidentialityDeed: (institutionConfidentialityDeed: Dtos.InstitutionConfidentialityDeed): Observable<Dtos.SetInstitutionConfidentialityDeedResponse> => {

        let request: Dtos.SetInstitutionConfidentialityDeed = new Dtos.SetInstitutionConfidentialityDeed();

        request.institutionConfidentialityDeed = institutionConfidentialityDeed;

        // send request
        const response: Promise<Dtos.SetInstitutionConfidentialityDeedResponse> = client.post(request);

        return Observable.from(response);
    },
    createInstitutionConfidentialityDeed: (institutionId: number): Observable<Dtos.CreateInstitutionConfidentialityDeedResponse> => {
        //Create the request.
        let request: Dtos.CreateInstitutionConfidentialityDeed = new Dtos.CreateInstitutionConfidentialityDeed();

        request.institutionId = institutionId;

        //Send request.
        const response: Promise<Dtos.CreateInstitutionConfidentialityDeedResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    deleteInstitutionConfidentialityDeed: (id: number): Observable<Dtos.DeleteInstitutionConfidentialityDeedResponse> => {
        //Create the request.
        let request: Dtos.DeleteInstitutionConfidentialityDeed = new Dtos.DeleteInstitutionConfidentialityDeed();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.DeleteInstitutionConfidentialityDeedResponse> = client.post(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    validateInstitutionConfidentialityDeed: (institutionConfidentialityDeed: Dtos.InstitutionConfidentialityDeed): Observable<Dtos.ValidateInstitutionConfidentialityDeedResponse> => {

        let request: Dtos.ValidateInstitutionConfidentialityDeed = new Dtos.ValidateInstitutionConfidentialityDeed();

        request.institutionConfidentialityDeed = institutionConfidentialityDeed;

        // send request
        const response: Promise<Dtos.ValidateInstitutionConfidentialityDeedResponse> = client.post(request);

        return Observable.from(response);
    },
}